const normalizeSearchValue = (value) =>
  String(value === null || value === undefined ? "" : value)
    .trim()
    .toLowerCase();

export const getAdminAccountRoles = (admin = {}) => {
  const roles = [admin.role]
    .concat(Array.isArray(admin.roles) ? admin.roles : [])
    .map((role) => String(role || "").trim())
    .filter(Boolean);

  return [...new Set(roles)];
};

const getAdminNodeSearchValues = (admin, nodeNamesByCode) => {
  const nodeCodes = (Array.isArray(admin.node) ? admin.node : [admin.node])
    .map((nodeCode) => String(nodeCode || "").trim())
    .filter(Boolean);

  return nodeCodes.reduce((values, nodeCode) => {
    const nodeName = nodeNamesByCode.get(nodeCode);
    return nodeName
      ? values.concat(nodeCode, nodeName, `${nodeName} (${nodeCode})`)
      : values.concat(nodeCode);
  }, []);
};

export const filterAdminAccounts = (
  admins,
  searchTerm = "",
  selectedRole = "",
  nodesList = [],
  accountType = ""
) => {
  const normalizedSearch = normalizeSearchValue(searchTerm);
  const normalizedRole = normalizeSearchValue(selectedRole);
  const nodeNamesByCode = new Map(
    (nodesList || []).map((node) => [
      String(node.nodecode || "").trim(),
      String(node.nodename || "").trim(),
    ])
  );

  return (Array.isArray(admins) ? admins : []).filter((admin) => {
    const roles = getAdminAccountRoles(admin);
    const type = admin.accountType || (roles.includes("patient") ? "patient" : "staff");
    if (accountType && type !== accountType) return false;
    const matchesRole =
      !normalizedRole ||
      roles.some((role) => normalizeSearchValue(role) === normalizedRole);

    if (!matchesRole || !normalizedSearch) {
      return matchesRole;
    }

    const searchableValues = [
      admin.firstname,
      admin.lastname,
      `${admin.firstname || ""} ${admin.lastname || ""}`,
      admin.displayName,
      admin.email,
      admin.phone,
      admin.hn,
      admin.source,
      admin.position,
      ...getAdminNodeSearchValues(admin, nodeNamesByCode),
      ...roles,
      ...roles.map((role) => role.replace(/_/g, " ")),
    ];

    return searchableValues.some((value) =>
      normalizeSearchValue(value).includes(normalizedSearch)
    );
  });
};

export const paginateAdminAccounts = (accounts, requestedPage, pageSize) => {
  const size = [10, 25, 50].includes(Number(pageSize)) ? Number(pageSize) : 25;
  const totalPages = Math.max(1, Math.ceil(accounts.length / size));
  const page = Math.min(totalPages, Math.max(1, Number(requestedPage) || 1));
  const offset = (page - 1) * size;
  return { rows: accounts.slice(offset, offset + size), page, totalPages, start: accounts.length ? offset + 1 : 0, end: Math.min(offset + size, accounts.length) };
};
